"use client";

import * as React from "react";
import cx from "clsx";
import Heading from "../Heading";
import Stack from "../Stack";
import Text from "../Text";
const CallOutBanner = ({
  children,
  illustration,
  actions,
  title,
  onClick,
  tabIndex,
  description,
  dataTest,
  id
}) =>
/*#__PURE__*/
// eslint-disable-next-line jsx-a11y/click-events-have-key-events
React.createElement("div", {
  className: cx("orbit-call-out-banner bg-white-normal rounded-50 p-400 lm:flex-row lm:p-600 flex flex-col items-start justify-start border border-solid text-start", onClick ? "shadow-level1 duration-fast hover:shadow-level2 active:shadow-level2 cursor-pointer border-transparent transition-shadow ease-in-out hover:outline-none active:outline-none" : "border-cloud-normal"),
  role: "button",
  onClick: onClick,
  tabIndex: (onClick || Number(tabIndex)) && (Number(tabIndex) || 0),
  "data-test": dataTest,
  id: id
}, illustration && /*#__PURE__*/React.createElement("div", {
  className: "pb-400 lm:pe-600 lm:pb-0"
}, illustration), /*#__PURE__*/React.createElement(Stack, {
  spacing: "400"
}, /*#__PURE__*/React.createElement(Stack, {
  spacing: "200"
}, /*#__PURE__*/React.createElement(Stack, {
  spacing: "100"
}, title && /*#__PURE__*/React.createElement(Heading, {
  type: "title3"
}, title), description && /*#__PURE__*/React.createElement(Text, null, description)), children), actions));
export default CallOutBanner;